import React, { Component } from 'react';
import Constants from '../../Config/Config';

class Frame extends Component {
	render() {
		const {selectedFrame, canvasFrameTotal} = this.props;
		return (
			<tr>
				<th>Frame Style</th>
				<td>{selectedFrame.size > 0 ? selectedFrame.get('name') : '-'}</td>
				<td>{selectedFrame.size > 0 ? Constants.Currency + canvasFrameTotal : '-'}</td>
			</tr>
		);
	}
}

export default Frame;